import React, { useEffect } from 'react';
import Contest from './weeklyContest';
import DailyAnalytics from './dailyAnalytics';
import MonthlyAnalytics from './monthlyAnalytics';
import { Typography } from '@mui/material';
import '../../../scss/pages/Home/HomeDashboard.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getLocalStoreString } from '../../../utils/Helper';
import { GET_DASHBOARD_LASTUPDATED } from '../../../sagas/type';
import { getDateWeek, msToTime } from '../../../components/common/DateTime/DateTime';
import clevertap from 'clevertap-web-sdk';
import { server } from '../../../configs/AppConfig';

function homeDashboard() {
    const dispatch = useDispatch();
    const { dashboardLastUpdatedData, } = useSelector(mapStateToProps);

    useEffect(() => {
        cleverTapTriggered()
        getLastUpdatedData()
    }, [])

    const cleverTapTriggered = () => {
        const EmployeeCode = getLocalStoreString("EmployeeCode");
        const FirstName = getLocalStoreString("FirstName");
        const LastName = getLocalStoreString("LastName");
        const EmployeeID = getLocalStoreString("EmployeeID");
        clevertap.spa = true
        clevertap.event.push("My Dashboard", {
            "Name": FirstName + ' ' + LastName,
            "Identity": EmployeeID,
            "Emp-Code": EmployeeCode,
            "Emp-Id": EmployeeID,
            "USER-TYPE": server == 'UAT' ? 'UAT User' : "PROD User",
        });
        // clevertap.event.push("My Dashboard2");
    }

    const getLastUpdatedData = () => {
        const contestId = getLocalStoreString("ContestId");
        const EmployeeCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: GET_DASHBOARD_LASTUPDATED,
            payload: { contestId, EmployeeCode },
        });
    };


    return (
        <div>
            {dashboardLastUpdatedData?.updatedDate && <div className='heading_title'>
                <Typography className='heading_title_title2' > Last Updated <span className='heading_title_title2_span-title' >{getDateWeek(dashboardLastUpdatedData?.lastUpdatedTimestamp)}</span> </Typography>
            </div>}
            <Contest />
            <DailyAnalytics />
            <MonthlyAnalytics />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        dashboardLastUpdatedData: state.dashboardConfig.dashboardLastUpdatedData,
    }
}

export default homeDashboard;